import {BatchSchema} from 'constants/SampleConstants';
import {
  SchemaAndColumnGroup,
  StructuredTableSchemaMetadata,
} from 'notebook/structured-tables/StructuredTableConstants';
import {Schema} from 'schemas/SchemaConstants';

export default function getSchemasWithColumnGroups(
  schemaMetadata: Array<StructuredTableSchemaMetadata>,
  schemas: Array<Schema | BatchSchema>
): Array<SchemaAndColumnGroup> | null {
  const schemasWithColumnGroups = [];
  for (const metadata of schemaMetadata) {
    const schema = schemas.find((s: Schema) => s.id === metadata.schemaId);
    if (schema == null) {
      // The user doesn't have permissions on the schema
      return null;
    }
    schemasWithColumnGroups.push({
      ...schema,
      columnGroup: metadata.group,
    });
  }
  return schemasWithColumnGroups;
}
